// Third party
import Grid from '@mui/material/Grid2';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';

// Components
import { useMemo } from 'react';
import { BaseChip, BaseHeader } from '../../../components/base';
import { useCommon } from '../../../hooks/useCommon';

const InventoryHeader = () => {
  const { t } = useTranslation('inventory');
  const { locationsByPermissions } = useCommon();

  const locationLength = useMemo(() => locationsByPermissions?.filter((location) => location.id > 1), [locationsByPermissions]);

  return (
    <Grid
      sx={{
        marginTop: { xs: 2 },
      }}
      marginTop={1}
      marginBottom={3}
      container
    >
      <Grid size={{
        lg: 8,
        md: 8,
        xs: 6,
        sm: 8,
      }}
      >
        <Box>
          <BaseHeader>
            {t('inventory')}
            <BaseChip label={`${locationLength?.length || 0} ${t('locations')}`} />
          </BaseHeader>
        </Box>
      </Grid>
    </Grid>
  );
};

export { InventoryHeader };
